export default __webpack_public_path__ + "static/media/aida.3ab994a4.png";